module.exports = __webpack_public_path__ + "static/media/admin.36eccc8a.svg";